import { makeStyles } from '@material-ui/core/styles';

const titleWidth = 180;

export const usePreviewBulkMetaRowsStyles = makeStyles(theme => ({
  previewBulkRow: {
    padding: theme.spacing(0.5, 1)
  },
  title: {
    minWidth: titleWidth,
    width: titleWidth
  },
  titleItem: {
    fontWeight: '500 !important'
  }
}));

export const useClickableStyles = makeStyles(theme => ({
  clickable: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
    marginRight: theme.spacing(0.5),
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}));
